export const TRANSLATION_FETCH_OVERVIEW =
  'translationActions/FETCH_OVERVIEW';
export const TRANSLATION_FETCH_OVERVIEW_SUCCESS =
  'translationActions/FETCH_OVERVIEW_SUCCESS';
export const TRANSLATION_FETCH_OVERVIEW_FAILED =
  'translationActions/FETCH_OVERVIEW_FAILED';
export const TRANSLATION_GENERATE = 'translationActions/GENERATE';
export const TRANSLATION_GENERATE_SUCCESS = 'translationActions/GENERATE_SUCCESS';
export const TRANSLATION_GENERATE_FAILED = 'translationActions/GENERATE_FAILED';
export const TRANSLATION_FETCH_CANDIDATE =
  'translationActions/FETCH_CANDIDATE';
export const TRANSLATION_FETCH_CANDIDATE_SUCCESS =
  'translationActions/FETCH_CANDIDATE_SUCCESS';
export const TRANSLATION_FETCH_CANDIDATE_FAILED =
  'translationActions/FETCH_CANDIDATE_FAILED';
export const TRANSLATION_ADOPT = 'translationActions/ADOPT';
export const TRANSLATION_ADOPT_SUCCESS = 'translationActions/ADOPT_SUCCESS';
export const TRANSLATION_ADOPT_FAILED = 'translationActions/ADOPT_FAILED';
export const TRANSLATION_RETRY_BATCH = 'translationActions/RETRY_BATCH';
export const TRANSLATION_RETRY_JOB = 'translationActions/RETRY_JOB';
export const TRANSLATION_RETRY_SUCCESS = 'translationActions/RETRY_SUCCESS';
export const TRANSLATION_RETRY_FAILED = 'translationActions/RETRY_FAILED';
export const TRANSLATION_START_POLL = 'translationActions/START_POLL';
export const TRANSLATION_STOP_POLL = 'translationActions/STOP_POLL';
export const TRANSLATION_POLL_DELAYED = 'translationActions/POLL_DELAYED';
export const TRANSLATION_CLEAR = 'translationActions/CLEAR';

export const experimentSideKey = (assignmentId, publicSideId) =>
  `${assignmentId}:${publicSideId}`;

export const fetchTranslationOverview = (postId) => ({
  type: TRANSLATION_FETCH_OVERVIEW,
  postId,
});
export const fetchTranslationOverviewSuccess = (postId, overview) => ({
  type: TRANSLATION_FETCH_OVERVIEW_SUCCESS,
  postId,
  overview,
});
export const fetchTranslationOverviewFailed = (postId, error) => ({
  type: TRANSLATION_FETCH_OVERVIEW_FAILED,
  postId,
  error,
});

// The server owns treatment allocation. The browser neither chooses nor
// learns provider/model identifiers.
export const generateTranslation = (postId, request = {}) => ({
  type: TRANSLATION_GENERATE,
  postId,
  targetLanguage: request.targetLanguage,
  allMissingTargets: request.allMissingTargets === true,
});
export const generateTranslationSuccess = (postId, result) => ({
  type: TRANSLATION_GENERATE_SUCCESS,
  postId,
  result,
});
export const generateTranslationFailed = (postId, error) => ({
  type: TRANSLATION_GENERATE_FAILED,
  postId,
  error,
});

export const fetchTranslationCandidate = (assignmentId, publicSideId) => ({
  type: TRANSLATION_FETCH_CANDIDATE,
  assignmentId,
  publicSideId,
  previewKey: experimentSideKey(assignmentId, publicSideId),
});
export const fetchTranslationCandidateSuccess = (
  previewKey,
  candidate,
  requestCycle = 0
) => ({
  type: TRANSLATION_FETCH_CANDIDATE_SUCCESS,
  previewKey,
  candidate,
  requestCycle,
});
export const fetchTranslationCandidateFailed = (
  previewKey,
  error,
  requestCycle = 0
) => ({
  type: TRANSLATION_FETCH_CANDIDATE_FAILED,
  previewKey,
  error,
  requestCycle,
});

export const adoptTranslationCandidate = (
  assignmentId,
  publicSideId,
  postId
) => ({
  type: TRANSLATION_ADOPT,
  assignmentId,
  publicSideId,
  postId,
  previewKey: experimentSideKey(assignmentId, publicSideId),
});
export const adoptTranslationCandidateSuccess = (previewKey, result) => ({
  type: TRANSLATION_ADOPT_SUCCESS,
  previewKey,
  result,
});
export const adoptTranslationCandidateFailed = (previewKey, error) => ({
  type: TRANSLATION_ADOPT_FAILED,
  previewKey,
  error,
});

export const retryTranslationJob = (
  assignmentId,
  publicSideId,
  postId,
  options = {}
) => ({
  type: TRANSLATION_RETRY_JOB,
  assignmentId,
  publicSideId,
  postId,
  previewKey: experimentSideKey(assignmentId, publicSideId),
  regenerate: options.regenerate === true,
});

// Retained as an exported name for nearby reducer/test compatibility. The v2
// editor contract exposes no batch identifier.
export const retryTranslationBatch = retryTranslationJob;
export const retryTranslationSuccess = (postId, result, resourceId) => ({
  type: TRANSLATION_RETRY_SUCCESS,
  postId,
  result,
  resourceId,
});
export const retryTranslationFailed = (postId, error, resourceId) => ({
  type: TRANSLATION_RETRY_FAILED,
  postId,
  error,
  resourceId,
});
export const startTranslationPoll = (postId) => ({
  type: TRANSLATION_START_POLL,
  postId,
});
export const stopTranslationPoll = (postId) => ({
  type: TRANSLATION_STOP_POLL,
  postId,
});
export const translationPollDelayed = (postId) => ({
  type: TRANSLATION_POLL_DELAYED,
  postId,
});
export const clearTranslationState = () => ({type: TRANSLATION_CLEAR});
